import * as pkceChallenge from 'pkce-challenge';

export const generatePkceChallenge =
  async (): Promise<Bluebeam.Auth.Models.AuthChallengePair> => {
    const challengePair = pkceChallenge.default();

    return {
      codeChallenge: challengePair.code_challenge,
      codeVerifier: challengePair.code_verifier,
    };
  };
